"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var polished_1 = require("polished");
var React = tslib_1.__importStar(require("react"));
var react_tooltip_lite_1 = tslib_1.__importDefault(require("react-tooltip-lite"));
var styled_components_1 = require("../Themes/styled-components");
var Styles = styled_components_1.createGlobalStyle(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  .react-tooltip-lite {\n    border-radius: ", ";\n    background: ", ";\n    color: ", ";\n    font-size: ", ";\n    * {\n      color: ", ";\n    }\n  }\n\n  .react-tooltip-lite-arrow {\n    border-color: ", ";\n  }\n"], ["\n  .react-tooltip-lite {\n    border-radius: ", ";\n    background: ", ";\n    color: ", ";\n    font-size: ", ";\n    * {\n      color: ", ";\n    }\n  }\n\n  .react-tooltip-lite-arrow {\n    border-color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.tooltip.borderRadius);
}, function (_a) {
    var theme = _a.theme;
    return theme.tooltip.backgroundColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.tooltip.textColor;
}, polished_1.rem(14), function (_a) {
    var theme = _a.theme;
    return theme.tooltip.textColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.tooltip.backgroundColor;
});
var Tooltip = function (_a) {
    var content = _a.content, children = _a.children;
    return (React.createElement(React.Fragment, null,
        React.createElement(Styles, null),
        React.createElement(react_tooltip_lite_1.default, { hoverDelay: 0, content: content, arrowSize: 6, distance: 8, padding: polished_1.rem(12) + " " + polished_1.rem(16), styles: { display: 'inline-flex' } }, children)));
};
exports.default = Tooltip;
var templateObject_1;
